import { lighten, List, ListItem, ListItemIcon, useTheme } from '@mui/material'
import { nanoid } from 'nanoid'
import { Link } from 'react-router-dom'

import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import getSocialDetails from '~/layouts/app/footer/termsAndSocial/social/utils'

function Social() {
  const theme = useTheme()
  const { partner } = usePartnerCentralized()
  const socialIcons = getSocialDetails(partner.socialLinks ?? [])

  return (
    <List
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        '& .MuiListItem-root': {
          width: 'auto',
          '& .MuiListItemIcon-root': {
            minWidth: 'auto',
            color: lighten(theme.palette.tertiary1, 0.8),
            '&:hover': {
              color: theme.palette.common.white,
            },
          },
        },
      }}
      dense
    >
      {socialIcons.map(({ icon, path }) => (
        <ListItem
          key={nanoid()}
          component={Link}
          to={path}
          disablePadding
          target="blank"
        >
          <ListItemIcon>{icon}</ListItemIcon>
        </ListItem>
      ))}
    </List>
  )
}

export default Social
